// Utility to provide mock data when backend is not available

// Mock settings data
export const mockSettings = {
  gymName: "Salle de Musculation",
  address: "Alger, Algérie",
  phone: "+213 XXX XXX XXX",
  email: "contact@gym.dz",
  website: "",
  currency: "DA",
  defaultLanguage: "fr",
  timezone: "Africa/Algiers",
  businessHours: {
    monday: { open: "06:00", close: "22:00", closed: false },
    tuesday: { open: "06:00", close: "22:00", closed: false },
    wednesday: { open: "06:00", close: "22:00", closed: false },
    thursday: { open: "06:00", close: "22:00", closed: false },
    friday: { open: "14:00", close: "22:00", closed: false },
    saturday: { open: "08:00", close: "20:00", closed: false },
    sunday: { open: "08:00", close: "18:00", closed: false }
  },
  notifications: {
    emailEnabled: true,
    smsEnabled: false,
    subscriptionReminders: true,
    paymentReminders: true,
    maintenanceAlerts: true
  },
  billing: {
    taxRate: 19,
    invoicePrefix: "INV",
    paymentTerms: 30,
    lateFee: 0
  },
  membership: {
    defaultPlan: "",
    gracePeriod: 3,
    autoRenewal: false,
    proRatedRefunds: true
  },
  security: {
    sessionTimeout: 1440,
    passwordMinLength: 8,
    requireTwoFactor: false,
    loginAttempts: 5
  }
};

// Mock sessions data
export const mockSessions = [
  {
    id: 1,
    memberId: 'M001',
    memberName: 'Ahmed Benaissa',
    memberCode: 'MEM-2023-001',
    checkInTime: new Date().toISOString(),
    checkOutTime: null,
    type: 'check-in',
    notes: '',
    memberPhoto: null
  },
  {
    id: 2,
    memberId: 'M002',
    memberName: 'Amina Khaldi',
    memberCode: 'MEM-2023-002',
    checkInTime: new Date().toISOString(),
    checkOutTime: null,
    type: 'check-in',
    notes: 'Programme personnalisé',
    memberPhoto: null
  },
  {
    id: 3,
    memberId: 'M003',
    memberName: 'Karim Mezouar',
    memberCode: 'MEM-2023-003',
    checkInTime: new Date(new Date().setHours(8, 30, 0, 0)).toISOString(),
    checkOutTime: new Date(new Date().setHours(9, 45, 0, 0)).toISOString(),
    type: 'check-in',
    notes: '',
    memberPhoto: null
  }
];

// Enhanced mock members data with more details
export const mockMembers = [
  {
    id: 'M001',
    code: 'MEM-2023-001',
    firstName: 'Ahmed',
    lastName: 'Benaissa',
    fullName: 'Ahmed Benaissa',
    email: 'ahmed@example.com',
    phone: '0555123456',
    address: '123 Rue Didouche Mourad, Alger',
    dateOfBirth: '1985-05-15',
    gender: 'homme',
    emergencyContact: '0555789123',
    status: 'active',
    photo: null,
    registrationDate: '2023-01-10',
    membershipType: 'premium',
    notes: 'Membre régulier depuis 2023'
  },
  {
    id: 'M002',
    code: 'MEM-2023-002',
    firstName: 'Amina',
    lastName: 'Khaldi',
    fullName: 'Amina Khaldi',
    email: 'amina@example.com',
    phone: '0555789012',
    address: '45 Boulevard des Martyrs, Alger',
    dateOfBirth: '1990-08-22',
    gender: 'femme',
    emergencyContact: '0555456789',
    status: 'active',
    photo: null,
    registrationDate: '2023-02-15',
    membershipType: 'standard',
    notes: 'Préfère les cours collectifs'
  },
  {
    id: 'M003',
    code: 'MEM-2023-003',
    firstName: 'Karim',
    lastName: 'Mezouar',
    fullName: 'Karim Mezouar',
    email: 'karim@example.com',
    phone: '0555234567',
    address: '78 Rue Larbi Ben M\'hidi, Alger',
    dateOfBirth: '1988-11-30',
    gender: 'homme',
    emergencyContact: '0555876543',
    status: 'active',
    photo: null,
    registrationDate: '2023-03-05',
    membershipType: 'premium',
    notes: 'Intéressé par le coaching personnel'
  },
  {
    id: 'M004',
    code: 'MEM-2023-004',
    firstName: 'Leila',
    lastName: 'Hadjadj',
    fullName: 'Leila Hadjadj',
    email: 'leila@example.com',
    phone: '0555345678',
    address: '12 Rue Hassiba Ben Bouali, Alger',
    dateOfBirth: '1992-04-18',
    gender: 'femme',
    emergencyContact: '0555987654',
    status: 'active',
    photo: null,
    registrationDate: '2023-03-20',
    membershipType: 'standard',
    notes: 'Préfère s\'entraîner le matin'
  },
  {
    id: 'M005',
    code: 'MEM-2023-005',
    firstName: 'Youcef',
    lastName: 'Belmadi',
    fullName: 'Youcef Belmadi',
    email: 'youcef@example.com',
    phone: '0555456789',
    address: '34 Rue Abane Ramdane, Alger',
    dateOfBirth: '1983-07-10',
    gender: 'homme',
    emergencyContact: '0555234987',
    status: 'inactive',
    photo: null,
    registrationDate: '2023-04-05',
    membershipType: 'basic',
    notes: 'Compte actuellement suspendu'
  },
  {
    id: 'M006',
    code: 'MEM-2023-006',
    firstName: 'Meriem',
    lastName: 'Boudiaf',
    fullName: 'Meriem Boudiaf',
    email: 'meriem@example.com',
    phone: '0555567890',
    address: '56 Boulevard Mohamed V, Alger',
    dateOfBirth: '1995-09-25',
    gender: 'femme',
    emergencyContact: '0555321654',
    status: 'active',
    photo: null,
    registrationDate: '2023-05-12',
    membershipType: 'premium',
    notes: 'Abonnement annuel'
  }
];

// Mock subscription plans
export const mockSubscriptionPlans = [
  {
    id: 'SP001',
    name: 'Standard',
    description: 'Accès de base à la salle de musculation',
    duration: 30,
    price: 3500,
    features: ['Accès aux équipements', 'Casier standard'],
    isActive: true
  },
  {
    id: 'SP002',
    name: 'Premium',
    description: 'Accès complet avec avantages supplémentaires',
    duration: 30,
    price: 5000,
    features: ['Accès aux équipements', 'Casier premium', 'Accès aux cours collectifs', 'Une session avec coach'],
    isActive: true
  },
  {
    id: 'SP003',
    name: 'Annuel',
    description: 'Abonnement annuel avec réduction',
    duration: 365,
    price: 30000,
    features: ['Tous les avantages Premium', 'Réduction de 15%', 'Sessions coach mensuelles'],
    isActive: true
  },
  {
    id: 'SP004',
    name: 'Étudiant',
    description: 'Offre spéciale pour les étudiants',
    duration: 30,
    price: 2500,
    features: ['Accès aux équipements', 'Casier standard', 'Horaires spécifiques'],
    isActive: true
  }
];

// Mock active subscriptions
export const mockSubscriptions = [
  {
    id: 'SUB001',
    memberId: 'M001',
    memberName: 'Ahmed Benaissa',
    planId: 'SP002',
    planName: 'Premium',
    startDate: '2024-01-10',
    endDate: '2024-02-10',
    status: 'active',
    amount: 5000,
    paymentStatus: 'paid',
    notes: ''
  },
  {
    id: 'SUB002',
    memberId: 'M002',
    memberName: 'Amina Khaldi',
    planId: 'SP001',
    planName: 'Standard',
    startDate: '2024-01-15',
    endDate: '2024-02-15',
    status: 'active',
    amount: 3500,
    paymentStatus: 'paid',
    notes: ''
  },
  {
    id: 'SUB003',
    memberId: 'M003',
    memberName: 'Karim Mezouar',
    planId: 'SP003',
    planName: 'Annuel',
    startDate: '2024-01-05',
    endDate: '2025-01-05',
    status: 'active',
    amount: 30000,
    paymentStatus: 'partial',
    notes: 'Paiement en plusieurs fois'
  }
];

// Export default empty function for potential future use
export default {}; 